import axios from 'axios';

class SlackService {
  constructor() {
    this.baseURL = 'https://slack.com/api';
    this.token = localStorage.getItem('slackToken');
  }

  async authenticate(code) {
    try {
      const response = await axios.post(`${this.baseURL}/oauth.v2.access`, {
        client_id: process.env.REACT_APP_SLACK_CLIENT_ID,
        client_secret: process.env.REACT_APP_SLACK_CLIENT_SECRET,
        code: code
      });

      if (response.data.ok) {
        // Store the access token and user ID
        localStorage.setItem('slackToken', response.data.access_token);
        localStorage.setItem('slackUserId', response.data.authed_user.id);
        this.token = response.data.access_token;
        return response.data;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      console.error('Slack authentication error:', error);
      throw error;
    }
  }

  async getChannels() {
    try {
      const response = await axios.get(`${this.baseURL}/conversations.list`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });

      if (response.data.ok) {
        return response.data.channels;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      console.error('Error fetching Slack channels:', error);
      throw error;
    }
  }

  async getChannelMessages(channelId) {
    try {
      const response = await axios.get(`${this.baseURL}/conversations.history`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        },
        params: {
          channel: channelId
        }
      });

      if (response.data.ok) {
        return response.data.messages;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      console.error('Error fetching Slack channel history:', error);
      throw error;
    }
  }

  async sendMessage(channelId, text) {
    try {
      const response = await axios.post(`${this.baseURL}/chat.postMessage`, {
        channel: channelId,
        text: text
      }, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });

      if (response.data.ok) {
        return response.data;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      console.error('Error sending Slack message:', error);
      throw error;
    }
  }
}

export default new SlackService(); 